import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Multiple = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Multiple' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M19,15 L23,15 L23,1 L9,1 L9,5 M15,19 L19,19 L19,5 L5,5 L5,9 M1,23 L15,23 L15,9 L1,9 L1,23 L1,23 L1,23 Z' />
  </StyledIcon>
);
